//Generated File 
export default class CommonConstants{
	static readonly ALLOWED_VALUES_PREFIX = `#ALWDVLS#`;
	static readonly ALWAYS_PRINT_ONE_BARCODE = `alwaysPrint1InBarcode`;
	static readonly APPROVAL_CHANGE = `approvalChange`;
	static readonly APPROVAL_MESSAGE = `approval`;
	static readonly ARABIC_KEYBOARD_ = [`ش`, `لا`, `ؤ`, `ي`, `ث`, `ب`, `ل`, `ا`, `ه`, `ت`, `ن`, `م`, `ة`, `ى`, `خ`, `ح`, `ض`, `ق`, `س`, `ف`, `ع`, `ر`, `ص`, `ء`, `غ`, `ئ`, `د`, `ج`, `ط`, `ك`, `ظ`, `ز`, `و`, `ذ`];
	static readonly ARABIC_REPLACE_BY = [`ا`, `ا`, `ا`, `ا`, `ا`, `ه`, `ه`, `ي`, `ي`, `و`, `و`];
	static readonly ARABIC_REPLACE___ = [`إ`, `ا`, `أ`, `آ`, `ء`, `ة`, `ه`, `ى`, `ئ`, `ؤ`, `و`];
	static readonly ATTACHMENT_COMPILED = `.compiled`;
	static readonly ATTACHMENT_FORCEDB = `forcedb`;
	static readonly ATTACHMENT_FORCEREPL = `forcerepl`;
	static readonly ATTACHMENT_FORCEREPLDB = `forcerepldb`;
	static readonly ATTACHMENT_JRXML = `.jrxml`;
	static readonly ATTACHMENT_MESSAGE = `attachment`;
	static readonly AddLineToGridAfterAutoSave = `addLineToGridAfterAutoSave`;
	static readonly AutoSaveAfterInputInFields = `autoSaveAfterInputInFields`;
	static readonly AutoSaveBehavior = `autoSaveBehavior`;
	static readonly BARCODEON = `BARCODEON`;
	static readonly BARCODE_URL_PREFIX = `namabarcode://`;
	static readonly BASE64_PREFIX = `@b64`;
	static readonly BG_IMAGE = `bgImag`;
	static readonly BULK_OPERATION = `@##blkop&&**`;
	static readonly CODE_AND_SATELITE_SEP = `$#`;
	static readonly CONTEXTFIELD_$_THIS = `$this`;
	static readonly CONTEXTFIELD_FORCE_SINGLE_COLUMN = `_FORCE_SINGLE_COLUMN__`;
	static readonly CONTEXTFIELD_SELECTEDLINE = `____SELECTED_LINE___`;
	static readonly CONTEXTFIELD_SELECTEDLINE_INDEX = `__$ELECTED_LINE___INDEX`;
	static readonly CONTEXTFIELD_VISIBLE_FIELDS = `_____VISIBLE_FIELDS___`;
	static readonly CONTEXTFIELD_WHOLELINE = `____ALL_LINE___`;
	static readonly CONTEXTFIELD_WHOLE_ENTITY = `_WHOLE_ENTITY__`;
	static readonly COPY_GRID_LINE = `.$$copyLine$$`;
	static readonly CRT_EXP_CURRENT_EMP_ID = `$currentempid`;
	static readonly CRT_EXP_CURRENT_USER_ID = `$currentuserid`;
	static readonly CapabilityDownloadAttachment = `DownloadAttachment`;
	static readonly CapabilityPreviewAttachment = `PreviewAttachment`;
	static readonly CapabilityUploadAttachment = `UploadAttachment`;
	static readonly CapabilityViewAttachment = `ViewAttachment`;
	static readonly DEFAULT_LAST_PAGE = 99999999;
	static readonly DEFAULT_VALUES_EXPRESSION_PRFX = `#exp#`;
	static readonly DEFAULT_VALUE_CURRENT_FISCAL_PERIOD = `$currentFiscalPeriod()`;
	static readonly DEFAULT_VALUE_CURRENT_USER = `$currentUser()`;
	static readonly DEFAULT_VALUE_CURRENT_USER_EMPLOYEE = `$currentUserEmployee()`;
	static readonly DEFAULT_VALUE_CURRENT_USER_RELATED_SUBSIDIARY = `$currentUserRelatedSubsidiary()`;
	static readonly DEFAULT_VALUE_CURRENT_VIEW_NAME = `$$$$$current__view_name@@@@`;
	static readonly DEFAULT_VALUE_HALVE_END = `$halveEnd()`;
	static readonly DEFAULT_VALUE_HALVE_START = `$halveStart()`;
	static readonly DEFAULT_VALUE_MINUS_DAYS = `$todayMinusDays(`;
	static readonly DEFAULT_VALUE_MINUS_MONTHS = `$todayMinusMonths(`;
	static readonly DEFAULT_VALUE_MINUS_WEEKS = `$todayMinusWeeks(`;
	static readonly DEFAULT_VALUE_MINUS_YEARS = `$todayMinusYears(`;
	static readonly DEFAULT_VALUE_MONTH_END = `$monthEnd()`;
	static readonly DEFAULT_VALUE_MONTH_START = `$monthStart()`;
	static readonly DEFAULT_VALUE_NEXT_MONTH_END = `$nextMonthEnd()`;
	static readonly DEFAULT_VALUE_NEXT_MONTH_START = `$nextMonthStart()`;
	static readonly DEFAULT_VALUE_NEXT_YEAR_END = `$nextYearEnd()`;
	static readonly DEFAULT_VALUE_NEXT_YEAR_START = `$nextYearStart()`;
	static readonly DEFAULT_VALUE_NOW = `$now()`;
	static readonly DEFAULT_VALUE_PLUS_DAYS = `$todayPlusDays(`;
	static readonly DEFAULT_VALUE_PLUS_MONTHS = `$todayPlusMonths(`;
	static readonly DEFAULT_VALUE_PLUS_PREFIX = `$todayPlus`;
	static readonly DEFAULT_VALUE_PLUS_WEEKS = `$todayPlusWeeks(`;
	static readonly DEFAULT_VALUE_PLUS_YEARS = `$todayPlusYears(`;
	static readonly DEFAULT_VALUE_PREVIOUS_MONTH_END = `$previousMonthEnd()`;
	static readonly DEFAULT_VALUE_PREVIOUS_MONTH_START = `$previousMonthStart()`;
	static readonly DEFAULT_VALUE_PREVIOUS_YEAR_END = `$previousYearEnd()`;
	static readonly DEFAULT_VALUE_PREVIOUS_YEAR_START = `$previousYearStart()`;
	static readonly DEFAULT_VALUE_QUARTER_END = `$quarterEnd()`;
	static readonly DEFAULT_VALUE_QUARTER_START = `$quarterStart()`;
	static readonly DEFAULT_VALUE_THIRD_END = `$thirdEnd()`;
	static readonly DEFAULT_VALUE_THIRD_START = `$thirdStart()`;
	static readonly DEFAULT_VALUE_TODAY = `$today()`;
	static readonly DEFAULT_VALUE_YEAR_END = `$yearEnd()`;
	static readonly DEFAULT_VALUE_YEAR_START = `$yearStart()`;
	static readonly DIRECT_PRINT = `directPrint`;
	static readonly EMAIL_CONTENT = `emailContent`;
	static readonly EMAIL_SUBJECT = `emailSubject`;
	static readonly ENGLISH_KEYBOARD = [`a`, `b`, `c`, `d`, `e`, `f`, `g`, `h`, `i`, `j`, `k`, `l`, `m`, `n`, `o`, `p`, `q`, `r`, `s`, `t`, `u`, `v`, `w`, `x`, `y`, `z`, `]`, `[`, `'`, `;`, `/`, `.`, `,`, `\``];
	static readonly ENTITY_CHANGE = `entityChange`;
	static readonly FAILED = `failed`;
	static readonly FIELD_INFO_ALLOWEDVALUES_SEPERATOR = `#,#`;
	static readonly FIELD_PARTS_SEP = `:`;
	static readonly FILTERS_PLACEHOLDER = `/*AND-FILTERS*/`;
	static readonly FISCAL_PERIOD_TYPE_FIELD = `periodType`;
	static readonly FISCAL_PERIOD_TYPE_PURGE = `PurgePeriod`;
	static readonly FindAddDescByEntityTypeQueryName = `FindAddDescByEntityTypeQuery`;
	static readonly FindByLoginIdQueryName = `FindByLoginIdQuery`;
	static readonly FindLayoutByPathQueryName = `FindLayoutByPath`;
	static readonly FocusFieldAfterAutoSave = `focusFieldAfterAutoSave`;
	static readonly GENERIC_REF_ALL = `&all`;
	static readonly GENERIC_REF_ALL_DOCS = `&alldocs`;
	static readonly GENERIC_REF_ALL_MASTERS = `&allmasters`;
	static readonly GENERIC_REF_SIMPLE_AND_ALL = `&sall`;
	static readonly GUI_MODULE_ID = 19;
	static readonly HEAD_OFFICE = `headoffice`;
	static readonly HIJRI_DATE = `hijriDate`;
	static readonly HMS_INVOICE_TYPES = [`HMSSurgeryInvoice`, `HMSAccommodationInvoice`, `HMSAttendantInvoice`, `HMSLabTestInvoice`, `HMSPatientCheckInvoice`, `HMSPhysicalTherapyInvoice`, `HMSRadiologyInvoice`, `HMSServicesInvoice`, `HMSSupervisionInvoice`, `HMSPharmacyInvoice`, `HMSSuppliesInvoice`, `HMSBloodBankInvoice`, `HMSServiceSupplyInvoice`, `HMSPharmacyReturn`, `HMSBloodBankReturn`, `HMSSupplyReturn`];
	static readonly HOPEFULLY_UNIQUE_FIELD_SEP = `_0_0_`;
	static readonly HOPEFULLY_UNIQUE_FIELD_SEP_FOR_SPLIT = `_0_0_`;
	static readonly HR_MIGRATION = `hrMigration`;
	static readonly IGNORED_FIELDS = [`allAdditionalFieldsInXMLDf`, `createTransactionId`, `lastModifyTransactionId`, `lastUpdateDate`];
	static readonly IMPL_BACKUP_TOKEN = `implBackupToken`;
	static readonly IMPL_BACKUP_TOKEN_CHECK = `implBackupTokenCheck`;
	static readonly JRXML_FILE_EXTENSION = `.jrxml`;
	static readonly LIST_FUNC_AVG = `avg`;
	static readonly LIST_FUNC_COUNT = `count`;
	static readonly LIST_FUNC_COUNT_DISTINCT = `count_distinct`;
	static readonly LIST_FUNC_MAX = `max`;
	static readonly LIST_FUNC_MIN = `min`;
	static readonly LIST_FUNC_SEP = `:`;
	static readonly LIST_FUNC_SUM = `sum`;
	static readonly LIST_PARAMS_SEP = `@A=@X`;
	static readonly LOCAL_RETRY_QUEUE = `localRetry`;
	static readonly LOGIN_LEGAL_ENTITY_LOGO = `leImag`;
	static readonly Layout_FilePath = `filePath`;
	static readonly ListAllConfigEntriesQueryName = `ListAllConfigEntriesQuery`;
	static readonly ListAllPickRulesQueryName = `ListAllPickRulesQueryName`;
	static readonly MORE_MENU_SEPERATOR = `:sep:`;
	static readonly MPS_AUTH = `mpsauth`;
	static readonly MPS_AUTH_RETRIEVE = `mpscheckauth`;
	static readonly MPS_CHECK = `checkmps`;
	static readonly MPS_CHECK_LEVEL = `checkmpslevel`;
	static readonly MPS_CHECK_LEVEL_USER_CODE = `checkmpsleveluser`;
	static readonly MPS_PREFIX = `M_oo_pS@~`;
	static readonly NAMA_EVENT_BUS_VERSION = 1;
	static readonly NOTIFICATION_CHANGE = `notificationChange`;
	static readonly NOTIFICATION_MESSAGE = `notificationMessage`;
	static readonly NO_ORDER = `@_NO_ORDER_@`;
	static readonly NUM_OF_ONLINE_ORDERS_TO_READ = 50;
	static readonly OLD_NO_ORDER = `%NO_ORDER%^^`;
	static readonly OPEN_LINK_IN_BROWSER_POPUP_WINDOW = `$$%%OpenInBrowserPopupWindow%^^&#`;
	static readonly OPEN_LINK_IN_NEW_WINDOW = `$$%%OpenInNewWindow%^^&#`;
	static readonly OPEN_LINK_IN_POPUP = `$$%%OpenInPopup%^^&#`;
	static readonly PERCENTAGE_SACLE = 2;
	static readonly POS_MODULE_ID = 127;
	static readonly P_HASH_START = `#**#P`;
	static readonly RATE_SCALE = 4;
	static readonly REPLACE_RECORD = `Replace_Current_Record`;
	static readonly REPORT_PARAM_ORIGINAL_PREFIX = `original_`;
	static readonly RE_COMMIT = `reCommit`;
	static readonly RUN_REPORT_SERVLET = `rpt?`;
	static readonly SEPARATOR = `_#_`;
	static readonly SYSTEM_FORMS_CODE_PREFIX = `SYSF-`;
	static readonly TO_EMAIL = `toEmail`;
	static readonly TO_EMP1 = `toEmp1`;
	static readonly UOMConversionScale = 10;
	static readonly URLS_SEPERATOR = `##11##22##3@@@3##44##55##`;
	static readonly URL_TITLE_SEPARATOR = `@!@`;
	static readonly WILD_CARD_REPLICATION_SITE = `*&`;
	static readonly ZIP_FILE_EXTENSION = `.zip`;
	static readonly aDATAGRID_PAGE_SIZE = 25;
	static readonly ignoreNotFoundReferencesAndAddThemToMap = `ignoreNotFoundReferencesAndAddThemToMap`;
	static readonly moveToNextRow = `__MOVE_TO_NEXT_ROW__`;
	static readonly notFoundRefsSet = `notFoundRefsSet`;
}
